import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.trainProgress;

const TrainProgressData = createSelector([selector], (state) => state);

export default {
  TrainProgressData
};
